/* import __COLOCATED_TEMPLATE__ from './details.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { TextField } from 'field-kit';
import ExpirationDateFormatter from '@banking/ui/utils/field-kit-formatters/expiration-date-formatter';
import { assertInstanceOf } from '@banking/ui/utils/assert';
const VALID_CVC_INPUT = /^(\s*|\d+)$/;
let Details = (_class = class Details extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  async initializeExpirationDateFieldKit(marketInputTextElement) {
    const inputElement = await marketInputTextElement.getInputElement();
    const formatter = new ExpirationDateFormatter();
    if (this.args.expiryDateValue) {
      // eslint-disable-next-line require-atomic-updates
      marketInputTextElement.value = formatter.format(this.args.expiryDateValue);
    }
    const fieldKit = new TextField(inputElement, formatter);
    const textDidChange = field => this.args.onExpiryDateChange(field.value());
    fieldKit.setDelegate({
      textDidChange
    });
  }

  // FIXME(cvu): Change any to unknown and type-narrow
  onCvcInputChange(event) {
    const value = assertInstanceOf(event, CustomEvent).detail.value;
    if (!VALID_CVC_INPUT.test(value)) {
      event.preventDefault();
      return;
    }
    this.args.onCvcChange(value);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "initializeExpirationDateFieldKit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeExpirationDateFieldKit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCvcInputChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCvcInputChange"), _class.prototype), _class);
export { Details as default };